/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PushPinSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,176a8.00008,8.00008,0,0,1-8,8H200.02393l-.0337.00146L199.95752,184H136v56a8,8,0,0,1-16,0V184H56.04248l-.03271.00146L55.97607,184H40a8,8,0,0,1,0-16h9.28857L70.46484,48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16h-6.46484l21.17627,120H216A8.00008,8.00008,0,0,1,224,176Z" />
    </Svg>
  );
}

export default PushPinSimple;
